import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Guarantee() {
  return <section className="bg-linen py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-36" data-mp="1o5zqy212ub4m">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.35
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-3xl rounded-[2rem] border border-wool bg-white p-8 text-center shadow-soft sm:p-12" data-id="element-37" data-mp="221byja0bzw2y">
        <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-sage/20 text-sage" data-id="element-38" data-mp="1j4k7geejscoc">
          <ShieldCheckIcon className="h-8 w-8" aria-hidden="true" data-id="element-39" data-mp="1edbxnh9b2pan" />
        </span>
        <h2 id="guarantee-title" className="mt-6 font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-40" data-mp="qo9gsbmhx0h7">
          Garantía de satisfacción de 7 días
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-41" data-mp="lon1zxr0rc6a">
          Tenés 7 días para revisar el método. Si sentís que no es para vos, te devolvemos el 100%
          de tu dinero. Queremos tejedoras felices, no clientes insatisfechos.
        </p>
        <div className="mx-auto mt-9 max-w-xl" data-id="element-42" data-mp="yqdyxrow6gc6">
          <CtaButton data-id="element-43" data-mp="yrp2bqefdm2r" />
        </div>
      </motion.div>
    </section>;
}